// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__1fusd","main":"NotFound_main__IBAJM"};